import styles from '@patternfly/react-styles/css/components/Table/table';
export const breakWord = () => ({
    className: styles.modifiers.breakWord
});
export const fitContent = () => ({
    className: styles.modifiers.fitContent
});
export const nowrap = () => ({
    className: styles.modifiers.nowrap
});
export const truncate = () => ({
    className: styles.modifiers.truncate
});
export const wrappable = () => ({
    className: styles.modifiers.wrap
});
//# sourceMappingURL=wrappable.js.map